import { render, staticRenderFns } from "./TextBasedSignaturePad.vue?vue&type=template&id=5bc6473a&scoped=true"
import script from "./TextBasedSignaturePad.vue?vue&type=script&lang=ts"
export * from "./TextBasedSignaturePad.vue?vue&type=script&lang=ts"
import style0 from "./TextBasedSignaturePad.vue?vue&type=style&index=0&id=5bc6473a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6473a",
  null
  
)

export default component.exports